import { autoinject } from "aurelia-dependency-injection";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import {
    GetOnboardingConfigResponse, SaveOnboardingConfigRequest, SaveOfferingRequest, SaveOfferingResponse,
    OnboardingRequestEntityConfigsResponse, GetOnboardingRequestResponse, UploadFilesResponse, OnboardingLandingPage,
    CloneOnboardingRequest, DeleteOnboardingConfigRequest,
    DeleteOnboardingConfigResponse, CloneOnboardingResponse, CreateDynamicOnboardingPluginRequest,
    CreateDynamicOnboardingPluginResponse,
    DeleteOnboardingPluginRequest,
    DeleteOnboardingPluginResponse,
    CloneOnboardingPluginRequest,
    CloneOnboardingPluginResponse,
    RunOnboardingRulesTestRequest,
    RunOnboardingRulesTestResponse
} from "../../models/onboarding/onboarding.models";
import { OnboardingAdminUrls } from '../../constants/onboarding/onboarding.constants';

@autoinject()
export class OnboardingAdminService {

    constructor(private requestClient: RequestClientService) {
    }

    getOnboardingRequest(id: number): Promise<GetOnboardingRequestResponse> {
        return this.requestClient.post(OnboardingAdminUrls.GetOnboardingRequest, {}, { onboardingRequestId: id });
    }

    getOnboardingConfig(id: number): Promise<GetOnboardingConfigResponse> {
        return this.requestClient.get(OnboardingAdminUrls.GetOnboardingConfig, { id });
    }

    getAvailableLandingPages(pluginId: number): Promise<OnboardingLandingPage[]> {
        return this.requestClient.get(OnboardingAdminUrls.GetAvailableLandingPages, { pluginId }) as Promise<OnboardingLandingPage[]>;
    }

    getODataModels(): Promise<OnboardingRequestEntityConfigsResponse> {
        return this.requestClient.get(OnboardingAdminUrls.GetODataModels, {});
    }

    saveOnboardingConfig(request: SaveOnboardingConfigRequest): Promise<any> {
        return this.requestClient.postFormData(OnboardingAdminUrls.SaveOnboardingConfig, request);
    }

    runOnboardingRulesTest(request: RunOnboardingRulesTestRequest): Promise<RunOnboardingRulesTestResponse> {
        return this.requestClient.post(OnboardingAdminUrls.RunOnboardingRulesTest, {}, request);
    }

    cloneOnboardingConfig(request: CloneOnboardingRequest): Promise<CloneOnboardingResponse> {
        return this.requestClient.post(OnboardingAdminUrls.CloneOnboardingConfig, {}, request);
    }

    cloneOnboardingPlugin(request: CloneOnboardingPluginRequest): Promise<CloneOnboardingPluginResponse> {
        return this.requestClient.post(OnboardingAdminUrls.CloneOnboardingPlugin, {}, request);
    }

    deleteOnboardingConfig(request: DeleteOnboardingConfigRequest): Promise<DeleteOnboardingConfigResponse> {
        return this.requestClient.delete(OnboardingAdminUrls.DeleteOnboardingConfig, {}, request);
    }

    deleteOnboardingPlugin(request: DeleteOnboardingPluginRequest): Promise<DeleteOnboardingPluginResponse> {
        return this.requestClient.delete(OnboardingAdminUrls.DeleteOnboardingPlugin, {}, request);
    }

    saveOffering(request: SaveOfferingRequest): Promise<SaveOfferingResponse> {
        return this.requestClient.postFormData(OnboardingAdminUrls.SaveOffering, request);
    }

    createDynamicOnboardingPlugin(request: CreateDynamicOnboardingPluginRequest): Promise<CreateDynamicOnboardingPluginResponse> {
        return this.requestClient.post(OnboardingAdminUrls.CreateDynamicOnboardingPlugin, {}, request);
    }

    uploadFiles(files: File[]): Promise<UploadFilesResponse> {
        const formData = new FormData();
        files.forEach(file => {
            formData.append(file.name, file);
        });
        return this.requestClient.postWithProgressCallback(OnboardingAdminUrls.UploadFiles, () => { }, {}, formData);
    }

    getSharedAccessSignatureToken(id: number, downloadFile: boolean): Promise<string> {
        return this.requestClient.get(OnboardingAdminUrls.GetSharedAccessSignatureToken, { onboardingRequestDocumentId: id, downloadFile });
    }
}
